import { ReactElement } from 'react';

import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  stallDetectionField: ReactElement;
};

export const StallDetectionSettingsContainer = ({
  stallDetectionField,
}: Props) => {
  const { title, description, docsLinkKey } =
    vpaSettingsConstants.stallDetection;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
    >
      {stallDetectionField}
    </VerticalSettingsForm>
  );
};
